import { render, staticRenderFns } from "./message.vue?vue&type=template&id=7736e072&scoped=true&"
import script from "./message.vue?vue&type=script&lang=js&"
export * from "./message.vue?vue&type=script&lang=js&"
import style0 from "./message.vue?vue&type=style&index=0&id=7736e072&prod&lang=stylus&scoped=true&"
import style1 from "./message.vue?vue&type=style&index=1&id=7736e072&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7736e072",
  null
  
)

export default component.exports